<template>
        <!-- 底部公司介绍 -->
        <footer class="tech-footer" >
    <div class="footer-container">
      <!-- 左侧信息区 -->
      <div class="info-columns">
        <!-- 第一列 -->
        <div class="info-col">
          <img src="../assets/logo.png" class="footer-logo">
          <div class="company-info">
            <p class="company-name">深圳市健希生物科技有限公司</p>
            <!-- <p class="certificate">互联网药品信息服务资格证（鲁）-非经营性-2023-0257</p> -->
          </div>
        </div>

        <!-- 第二列 -->
        <div class="info-col">
          <p><i class="el-icon-phone"></i> 联系方式：0755-22370171</p>
          <p><i class="el-icon-message"></i> 775732043@qq.com</p>
          <p><i class="el-icon-location"></i> 公司地址：广东省深圳市罗湖区文锦中路锦绣大厦A座23B</p>
          <!-- <p><i class="el-icon-office-building"></i> 工厂地址：深圳市龙岗区南湾街道李朗大道盛宝路2号中海信创新产业城5栋2楼</p> -->
        </div>
      </div>

      <!-- 右侧导航区 -->
      <div class="nav-columns">
        <!-- 二维码区 -->
        <div class="qrcode-box">
          <img src="../assets/gzhaoerwm.jpg" class="qrcode">
          <p>官方微信公众号</p>
        </div>
      </div>
    </div>
  </footer>
  </template>
  
  <script>
  export default {
    name: 'Footer'
  };
  </script>
  
  <style scoped>
/* 底部公司介绍 */
.tech-footer {
  background-color: #001529;
  color: white;
  padding: 40px 0;
  position: relative;
  background-size: cover;
  background-blend-mode: multiply;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.info-columns {
  width: 45%;
  display: flex;
}

.info-col {
  flex: 1;
  padding-right: 30px;
}

.footer-logo {
  width: 100px;
  height: 100px;
  margin-bottom: 15px;
}

.company-name {
  font-size: 18px;
  margin-bottom: 10px;
}

.certificate {
  color: #888;
  font-size: 12px;
}

.nav-columns {
  width: 50%;
  position: relative;
}

.nav-title {
  color: #00f0ff;
  font-size: 16px;
  margin-bottom: 15px;
}

.nav-col ul {
  list-style: none;
  padding: 0;
}

.nav-col li {
  margin: 8px 0;
}

.nav-col a {
  color: white;
  text-decoration: none;
  transition: color 0.3s;
}

.nav-col a:hover {
  color: #00f0ff;
}

.qrcode-box {
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
}

.qrcode {
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
}

/* 图标样式 */
.el-icon-phone,
.el-icon-message,
.el-icon-location,
.el-icon-office-building {
  margin-right: 8px;
  color: #00f0ff;
}
  </style>